import zipToTz from 'zip-to-tz';

/** `60601-1234` and ` 60601 ` are the same five digits the lookup indexes on. */
const toFiveDigits = (zipCode: string) => zipCode.trim().slice(0, 5);

/**
 * Zone the visitor reads their callback times in, taken from the ZIP code they gave in the
 * contact step. The lookup already answers with IANA names, which `Intl` formats with directly,
 * so the value is used as-is. `null` means the ZIP told us nothing and leaves the fallback to
 * the caller, which knows the office zone.
 */
export function resolveVisitorTimeZone(zipCode: string): string | null {
  return zipToTz(toFiveDigits(zipCode)) ?? null;
}
